
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Download } from "lucide-react";

interface DownloadItem {
  id: number;
  title: string;
  type: string;
  size: string;
  date: string;
}

interface DownloadHistoryProps {
  downloads: DownloadItem[];
}

export const DownloadHistory = ({ downloads }: DownloadHistoryProps) => (
  <Card className="md:col-span-2">
    <CardHeader>
      <CardTitle className="flex items-center">
        <Download className="mr-2 h-5 w-5" />
        Downloads
      </CardTitle>
      <CardDescription>Your downloaded resources</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="space-y-4">
        {downloads.map((download) => (
          <div key={download.id} className="border-b pb-4 last:border-0 last:pb-0">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-medium">{download.title}</h3>
                <p className="mt-1 text-sm text-gray-500">
                  {download.type} • {download.size} • {download.date}
                </p>
              </div>
              <Button variant="outline" size="sm" className="flex items-center">
                <Download className="mr-2 h-4 w-4" />
                Download Again
              </Button>
            </div>
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
);
